<template>
    <div>  
        <component :is='tela'
            :proposta-id="propostaId"
            :proposta-original-id="propostaOriginalId"
            :endpoint="endpoint" 
            :aprovada="aprovada"
            :duration="duracao"
            :duracao="duracao"
            :componente="tela"

            :chave-permissao="chavePermissao"

            :ref="tela"
            @update="update"
        />
    </div>
</template>
<script>

export default {
    name: 'componentes_proposta',
    props : {
        tela : {
            type: String,
            required: true
        },
        duracao : {
            default : 0,
        },
        propostaId : {
            required : true
        },
        propostaOriginalId : {
            required : true
        },
        endpoint : {
            type : String,
            required : true
        },
        aprovada: {
            type: Boolean,
            default: false
        },
        chavePermissao: {
            type: String,
            default: null
        }
    },
    components : {    
        'descricao_tecnica': () => import('./accordions/descricao_tecnica/'),    
        'ee': () => import('./accordions/empresas/'),
        'rh': () => import('./accordions/recurso_humano/'),
        'st': () => import('./accordions/rubricas/'),
        'mc': () => import('./accordions/rubricas/'),
        'mpe': () => import('./accordions/rubricas/'),
        'vd': () => import('./accordions/rubricas/'),
        'ou': () => import('./accordions/rubricas/'),
        'ce': () => import('./accordions/cronograma_etapa/'),
        'e': () => import('./accordions/entregaveis/'),
        'cf': () => import('./accordions/cronograma_financeiro/'),
        'investimentos': () => import('./accordions/investimento/'), 
        'investimentos_executora': () => import('./accordions/investimento_executora/') 
        
    },
    methods:{
        update(){
            this.$emit('update');
        },
        montar(tela){
            /* eslint-disable */
            try{
                this.$refs[tela].montar();
            }catch(e){
            }
        }
    }
}
</script>
<style lang="">
    
</style>